import Query from "../Query";
import FooterMap from "./FooterMap";

import KONTAKT_QUERY from "../../queries/kontakt";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import mainLogo from "../../img/logo.svg";

import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer layout layout__min layout__bg layout__bg_primary">
      <Container fluid>
        <Row>
          <Col data-aos="fade-up" data-aos-offset="200" xs={12} md={6} lg={4}>
            <img src={mainLogo} alt="Fahrschule Bergedorf" className="w-100" />
          </Col>

          <Query query={KONTAKT_QUERY}>
            {({ data: { categories, contact } }) => {
              const filteredCategories = categories.data.filter(
                (category) => category.attributes.slug.length <= 5,
              );

              const kontakt = contact.data.attributes;

              return (
                <>
                  <Col
                    xs={12}
                    md={6}
                    lg={{
                      span: 6,
                      offset: 2,
                    }}
                  >
                    <Row>
                      <Col xs={12} lg={4}>
                        <h4 data-aos="fade-up" className="footer_title">
                          Information
                        </h4>
                        <ul className="footer_links">
                          <li data-aos="fade-up">
                            <Link to="/preise">Preise</Link>
                          </li>
                          <li data-aos="fade-up">
                            <Link to="/team">Über Uns</Link>
                          </li>
                          {/* <li data-aos="fade-up">
                            <Link to="/preise">Jobs</Link>
                          </li> */}
                          <li data-aos="fade-up">
                            <Link to="/kontakt">Kontakt</Link>
                          </li>
                        </ul>
                      </Col>
                      <Col xs={6} md={6} lg={4}>
                        <h4 data-aos="fade-up" className="footer_title">
                          <Link to="/fuehrerscheine">Führerscheine</Link>
                        </h4>
                        <ul className="footer_links">
                          <li data-aos="fade-up">
                            <Link to={`/fuehrerscheine/a`}>A</Link>
                          </li>
                          {filteredCategories.map((category) => (
                            <li
                              data-aos="fade-up"
                              key={category.attributes.slug}
                            >
                              <Link
                                to={`/fuehrerscheine/${category.attributes.slug}`}
                              >
                                {category.attributes.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </Col>
                      <Col xs={6} md={6} lg={4}>
                        <h4 data-aos="fade-up" className="footer_title">
                          Kursen
                        </h4>
                        <ul className="footer_links">
                          {/* <li data-aos="fade-up">
                            <Link to="/theorie">Theorie</Link>
                          </li>
                          <li data-aos="fade-up">
                            <Link to="/praxis">Praxis</Link>
                          </li> */}
                          <li data-aos="fade-up">
                            <Link to="/erste-hilfe">Erste Hilfe</Link>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} lg={6}>
                    <Row>
                      <Col xs={12} md={6}>
                        <h4 data-aos="fade-up" className="footer_title mb-3">
                          Filiale 1
                        </h4>
                        <div data-aos="fade-up" className="max-w-300 mb-3">
                          <a
                            href="https://maps.app.goo.gl/4cgovCNBWGZy5kpBA"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer_link footer_link__accent fw-400"
                          >
                            {kontakt.address.split("/n").map((line, index) => (
                              <span key={index}>
                                {line}
                                <br />
                              </span>
                            ))}
                          </a>
                        </div>
                        {kontakt.telephone !== null && (
                          <div data-aos="fade-up" className="footer_text mt-2">
                            Tel:{" "}
                            <a
                              href={"tel:" + kontakt.telephone}
                              className="footer_link footer_link__accent"
                            >
                              {kontakt.telephone}
                            </a>
                          </div>
                        )}
                        {kontakt.mobile !== null && (
                          <div data-aos="fade-up" className="footer_text mt-2">
                            Mobil:{" "}
                            <a
                              href={"tel:" + kontakt.mobile}
                              className="footer_link footer_link__accent"
                            >
                              {kontakt.mobile}
                            </a>
                          </div>
                        )}
                        <p
                          className="footer_text footer_text__small mt-2"
                          data-aos="fade-up"
                          dangerouslySetInnerHTML={{
                            __html: kontakt.helptime,
                          }}
                        ></p>
                      </Col>
                      <Col xs={12} md={6}>
                        <h4 data-aos="fade-up" className="footer_title mb-3">
                          Filiale 2
                        </h4>
                        <div data-aos="fade-up" className="max-w-300 mb-3">
                          <a
                            href="https://maps.app.goo.gl/xwC8tXXBMMn2KHnA7"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer_link footer_link__accent fw-400"
                          >
                            Alte Holstenstraße 29
                            <br />
                            21031 Hamburg
                          </a>
                        </div>
                        {true && (
                          <div data-aos="fade-up" className="footer_text mt-2">
                            Tel:{" "}
                            <a
                              href={"tel:" + "04041281956"}
                              className="footer_link footer_link__accent"
                            >
                              040 41281956
                            </a>
                          </div>
                        )}
                        {true && (
                          <div data-aos="fade-up" className="footer_text mt-2">
                            Mobil:{" "}
                            <a
                              href={"tel:" + "0179 7591216"}
                              className="footer_link footer_link__accent"
                            >
                              0179 7591216
                            </a>
                          </div>
                        )}
                        <p
                          className="footer_text footer_text__small mt-2"
                          data-aos="fade-up"
                        >
                          Bürozeiten:
                          <br />
                          Mo. bis Fr. 12:00 bis 18:00 Uhr,
                          <br />
                          Sa. 11:00 bis 15:00 Uhr
                        </p>
                      </Col>
                      <Col xs={12} className="d-none d-lg-block">
                        <h4 data-aos="fade-up" className="footer_title mb-3">
                          E-mail
                        </h4>
                        {kontakt.email !== null && (
                          <div data-aos="fade-up" className=" mb-2">
                            <a
                              href={"mailto:" + kontakt.email}
                              className="footer_link footer_link__accent"
                            >
                              {kontakt.email}
                            </a>
                          </div>
                        )}
                      </Col>
                      <Col xs={12} className="d-none d-lg-block">
                        <h4 data-aos="fade-up" className="footer_title mb-3">
                          Soziale Medien
                        </h4>
                        <div
                          className="d-flex align-items-center gap-12"
                          data-aos="fade-up"
                        >
                          <a
                            href={kontakt.Facebook}
                            target="_blank"
                            rel="noreferrer"
                            className="footer_social"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_148_3018)">
                                <path d="M30 4.375H10C7.23877 4.375 5 6.61377 5 9.375V29.375C5 32.1362 7.23877 34.375 10 34.375H20.625V23.75H16.875V19.375H20.625V16.25C20.625 11.875 23.125 9.375 26.875 9.375C28.833 9.375 30 10 30 10V13.75H27.5C25.7129 13.75 25 15.0586 25 16.25V19.375H29.375L28.75 23.75H25V34.375H30C32.7612 34.375 35 32.1362 35 29.375V9.375C35 6.61377 32.7612 4.375 30 4.375Z" />
                              </g>
                              <defs>
                                <clipPath id="clip0_148_3018">
                                  <rect width="40" height="40" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </a>

                          <a
                            href={kontakt.Instagram}
                            target="_blank"
                            rel="noreferrer"
                            className="footer_social"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                              fill="none"
                            >
                              <rect
                                x="6.5"
                                y="6.70996"
                                width="27"
                                height="27"
                                rx="3.5"
                                stroke="white"
                                strokeWidth="3"
                              />
                              <path
                                d="M27.808 6.91016H16.7706C13.6138 6.91016 11.0547 9.46925 11.0547 12.626V24.2113C11.0547 27.3681 13.6138 29.9272 16.7706 29.9272H27.808C30.9648 29.9272 33.5239 27.3681 33.5239 24.2113V12.626C33.5239 9.46925 30.9648 6.91016 27.808 6.91016Z"
                                fill="#00664E"
                              />
                              <path d="M13.3335 5.20996C11.1234 5.21016 9.00382 6.08822 7.44104 7.651C5.87826 9.21378 5.0002 11.3333 5 13.5434V26.8742C4.9998 27.9687 5.2152 29.0526 5.63389 30.0639C6.05259 31.0752 6.66638 31.9941 7.44023 32.7681C8.21407 33.5422 9.13281 34.1562 10.144 34.5752C11.1551 34.9942 12.2389 35.2099 13.3335 35.21H26.6642C27.759 35.2102 28.843 34.9947 29.8544 34.5758C30.8659 34.157 31.7849 33.543 32.559 32.7689C33.333 31.9948 33.947 31.0758 34.3659 30.0644C34.7847 29.053 35.0002 27.9689 35 26.8742V13.5434C34.9999 12.4489 34.7842 11.3651 34.3652 10.3539C33.9463 9.34277 33.3322 8.42403 32.5581 7.65019C31.7841 6.87634 30.8652 6.26255 29.8539 5.84385C28.8426 5.42516 27.7588 5.20976 26.6642 5.20996H13.3335ZM30.0004 8.54304C30.3299 8.54319 30.652 8.64104 30.926 8.82422C31.1999 9.0074 31.4134 9.26769 31.5394 9.57218C31.6655 9.87666 31.6984 10.2117 31.6341 10.5349C31.5698 10.8581 31.4111 11.155 31.178 11.388C30.945 11.621 30.6481 11.7797 30.3249 11.8441C30.0017 11.9084 29.6667 11.8754 29.3622 11.7494C29.0577 11.6234 28.7974 11.4099 28.6143 11.1359C28.4311 10.862 28.3332 10.5399 28.3331 10.2103C28.3331 9.99139 28.3762 9.77458 28.46 9.57229C28.5438 9.37001 28.6666 9.1862 28.8214 9.03138C28.9762 8.87656 29.16 8.75374 29.3623 8.66995C29.5646 8.58617 29.7814 8.54304 30.0004 8.54304ZM20.0004 11.8769C21.6486 11.8769 23.2598 12.3656 24.6302 13.2813C26.0006 14.197 27.0688 15.4985 27.6995 17.0213C28.3302 18.544 28.4953 20.2196 28.1737 21.8361C27.8522 23.4527 27.0585 24.9375 25.893 26.103C24.7276 27.2684 23.2427 28.0621 21.6262 28.3837C20.0096 28.7052 18.334 28.5402 16.8113 27.9095C15.2886 27.2787 13.9871 26.2106 13.0714 24.8402C12.1557 23.4697 11.6669 21.8585 11.6669 20.2103C11.6671 18.0002 12.5452 15.8807 14.108 14.3179C15.6707 12.7551 17.7903 11.8771 20.0004 11.8769ZM20.0004 15.21C19.0114 15.21 18.0446 15.5032 17.2223 16.0527C16.4 16.6021 15.7591 17.3831 15.3806 18.2968C15.0022 19.2105 14.9031 20.2159 15.0961 21.1859C15.289 22.1558 15.7653 23.0468 16.4646 23.7461C17.1639 24.4455 18.0549 24.9217 19.0249 25.1146C19.9948 25.3076 21.0002 25.2086 21.9139 24.8301C22.8276 24.4516 23.6086 23.8107 24.158 22.9884C24.7075 22.1661 25.0008 21.1993 25.0008 20.2103C25.0008 18.8842 24.4739 17.6123 23.5362 16.6745C22.5984 15.7368 21.3266 15.21 20.0004 15.21Z" />
                            </svg>
                          </a>

                          <a
                            href={kontakt.TikTok}
                            target="_blank"
                            rel="noreferrer"
                            className="footer_social"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                              fill="none"
                            >
                              <path d="M30 5H10C7.23877 5 5 7.23877 5 10V30C5 32.7612 7.23877 35 10 35H30C32.7612 35 35 32.7612 35 30V10C35 7.23877 32.7612 5 30 5ZM31.25 16.875C28.772 16.875 26.9458 16.1938 25.625 15.1904V24.0625C25.625 28.0249 22.3999 31.25 18.4375 31.25C14.4751 31.25 11.25 28.0249 11.25 24.0625C11.25 20.1001 14.4751 16.875 18.4375 16.875H19.6875V20H18.4375C16.1963 20 14.375 21.8213 14.375 24.0625C14.375 26.3037 16.1963 28.125 18.4375 28.125C20.6787 28.125 22.5 26.3037 22.5 24.0625V8.75H25.625C25.6372 9.57764 25.957 13.75 31.25 13.75V16.875Z" />
                            </svg>
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} lg={6}>
                    <FooterMap />
                  </Col>
                  <Col xs={12} className="d-lg-none">
                    <h4 data-aos="fade-up" className="footer_title mb-3">
                      E-mail
                    </h4>
                    {kontakt.email !== null && (
                      <div data-aos="fade-up" className=" mb-2">
                        <a
                          href={"mailto:" + kontakt.email}
                          className="footer_link footer_link__accent"
                        >
                          {kontakt.email}
                        </a>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} className="d-lg-none">
                    <h4 data-aos="fade-up" className="footer_title mb-3">
                      Soziale Medien
                    </h4>
                    <div
                      className="d-flex align-items-center gap-12"
                      data-aos="fade-up"
                    >
                      <a
                        href={kontakt.Facebook}
                        target="_blank"
                        rel="noreferrer"
                        className="footer_social"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_148_3018)">
                            <path d="M30 4.375H10C7.23877 4.375 5 6.61377 5 9.375V29.375C5 32.1362 7.23877 34.375 10 34.375H20.625V23.75H16.875V19.375H20.625V16.25C20.625 11.875 23.125 9.375 26.875 9.375C28.833 9.375 30 10 30 10V13.75H27.5C25.7129 13.75 25 15.0586 25 16.25V19.375H29.375L28.75 23.75H25V34.375H30C32.7612 34.375 35 32.1362 35 29.375V9.375C35 6.61377 32.7612 4.375 30 4.375Z" />
                          </g>
                          <defs>
                            <clipPath id="clip0_148_3018">
                              <rect width="40" height="40" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>

                      <a
                        href={kontakt.Instagram}
                        target="_blank"
                        rel="noreferrer"
                        className="footer_social"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <rect
                            x="6.5"
                            y="6.70996"
                            width="27"
                            height="27"
                            rx="3.5"
                            stroke="white"
                            strokeWidth="3"
                          />
                          <path
                            d="M27.808 6.91016H16.7706C13.6138 6.91016 11.0547 9.46925 11.0547 12.626V24.2113C11.0547 27.3681 13.6138 29.9272 16.7706 29.9272H27.808C30.9648 29.9272 33.5239 27.3681 33.5239 24.2113V12.626C33.5239 9.46925 30.9648 6.91016 27.808 6.91016Z"
                            fill="#00664E"
                          />
                          <path d="M13.3335 5.20996C11.1234 5.21016 9.00382 6.08822 7.44104 7.651C5.87826 9.21378 5.0002 11.3333 5 13.5434V26.8742C4.9998 27.9687 5.2152 29.0526 5.63389 30.0639C6.05259 31.0752 6.66638 31.9941 7.44023 32.7681C8.21407 33.5422 9.13281 34.1562 10.144 34.5752C11.1551 34.9942 12.2389 35.2099 13.3335 35.21H26.6642C27.759 35.2102 28.843 34.9947 29.8544 34.5758C30.8659 34.157 31.7849 33.543 32.559 32.7689C33.333 31.9948 33.947 31.0758 34.3659 30.0644C34.7847 29.053 35.0002 27.9689 35 26.8742V13.5434C34.9999 12.4489 34.7842 11.3651 34.3652 10.3539C33.9463 9.34277 33.3322 8.42403 32.5581 7.65019C31.7841 6.87634 30.8652 6.26255 29.8539 5.84385C28.8426 5.42516 27.7588 5.20976 26.6642 5.20996H13.3335ZM30.0004 8.54304C30.3299 8.54319 30.652 8.64104 30.926 8.82422C31.1999 9.0074 31.4134 9.26769 31.5394 9.57218C31.6655 9.87666 31.6984 10.2117 31.6341 10.5349C31.5698 10.8581 31.4111 11.155 31.178 11.388C30.945 11.621 30.6481 11.7797 30.3249 11.8441C30.0017 11.9084 29.6667 11.8754 29.3622 11.7494C29.0577 11.6234 28.7974 11.4099 28.6143 11.1359C28.4311 10.862 28.3332 10.5399 28.3331 10.2103C28.3331 9.99139 28.3762 9.77458 28.46 9.57229C28.5438 9.37001 28.6666 9.1862 28.8214 9.03138C28.9762 8.87656 29.16 8.75374 29.3623 8.66995C29.5646 8.58617 29.7814 8.54304 30.0004 8.54304ZM20.0004 11.8769C21.6486 11.8769 23.2598 12.3656 24.6302 13.2813C26.0006 14.197 27.0688 15.4985 27.6995 17.0213C28.3302 18.544 28.4953 20.2196 28.1737 21.8361C27.8522 23.4527 27.0585 24.9375 25.893 26.103C24.7276 27.2684 23.2427 28.0621 21.6262 28.3837C20.0096 28.7052 18.334 28.5402 16.8113 27.9095C15.2886 27.2787 13.9871 26.2106 13.0714 24.8402C12.1557 23.4697 11.6669 21.8585 11.6669 20.2103C11.6671 18.0002 12.5452 15.8807 14.108 14.3179C15.6707 12.7551 17.7903 11.8771 20.0004 11.8769ZM20.0004 15.21C19.0114 15.21 18.0446 15.5032 17.2223 16.0527C16.4 16.6021 15.7591 17.3831 15.3806 18.2968C15.0022 19.2105 14.9031 20.2159 15.0961 21.1859C15.289 22.1558 15.7653 23.0468 16.4646 23.7461C17.1639 24.4455 18.0549 24.9217 19.0249 25.1146C19.9948 25.3076 21.0002 25.2086 21.9139 24.8301C22.8276 24.4516 23.6086 23.8107 24.158 22.9884C24.7075 22.1661 25.0008 21.1993 25.0008 20.2103C25.0008 18.8842 24.4739 17.6123 23.5362 16.6745C22.5984 15.7368 21.3266 15.21 20.0004 15.21Z" />
                        </svg>
                      </a>

                      <a
                        href={kontakt.TikTok}
                        target="_blank"
                        rel="noreferrer"
                        className="footer_social"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <path d="M30 5H10C7.23877 5 5 7.23877 5 10V30C5 32.7612 7.23877 35 10 35H30C32.7612 35 35 32.7612 35 30V10C35 7.23877 32.7612 5 30 5ZM31.25 16.875C28.772 16.875 26.9458 16.1938 25.625 15.1904V24.0625C25.625 28.0249 22.3999 31.25 18.4375 31.25C14.4751 31.25 11.25 28.0249 11.25 24.0625C11.25 20.1001 14.4751 16.875 18.4375 16.875H19.6875V20H18.4375C16.1963 20 14.375 21.8213 14.375 24.0625C14.375 26.3037 16.1963 28.125 18.4375 28.125C20.6787 28.125 22.5 26.3037 22.5 24.0625V8.75H25.625C25.6372 9.57764 25.957 13.75 31.25 13.75V16.875Z" />
                        </svg>
                      </a>
                    </div>
                  </Col>
                  <Col xs={12}>
                    <hr className="footer_line" />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="d-flex flex-column flex-md-row gap-3 justify-content-sm-between"
                  >
                    <div data-aos="fade-up">
                      <a href="/datenschutz" className="footer_link">
                        Datenschutz
                      </a>
                    </div>
                    <div data-aos="fade-up">
                      <a href="/impressum" className="footer_link">
                        Impressum
                      </a>
                    </div>
                    <div data-aos="fade-up">
                      <a href="/agb" className="footer_link">
                        AGB
                      </a>
                    </div>
                  </Col>

                  <Col
                    xs={12}
                    md={6}
                    lg={8}
                    className="d-flex justify-content-md-end"
                  >
                    <p
                      data-aos="fade-up"
                      className="footer_text footer_text__small"
                    >
                      Made by:{" "}
                      <a
                        href="https://otruta.agency/"
                        target="_blank"
                        rel="noreferrer"
                        className="footer_link footer_link__accent footer_link__small"
                      >
                        OTRUTA.AGENCY
                      </a>
                    </p>
                  </Col>
                </>
              );
            }}
          </Query>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
